import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useI18n } from "@/lib/i18n";
import { useContent } from "@/lib/content";

const renderMarkdown = (md) => {
  if (!md) return null;
  const lines = md.split("\n");
  const out = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      out.push(<ul key={`ul-${out.length}`}>{listBuf}</ul>);
      listBuf = [];
    }
  };
  lines.forEach((ln, i) => {
    if (ln.startsWith("# ")) { flushList(); out.push(<h1 key={i}>{ln.slice(2)}</h1>); }
    else if (ln.startsWith("## ")) { flushList(); out.push(<h2 key={i}>{ln.slice(3)}</h2>); }
    else if (ln.startsWith("### ")) { flushList(); out.push(<h3 key={i}>{ln.slice(4)}</h3>); }
    else if (ln.startsWith("- ")) { listBuf.push(<li key={i}>{ln.slice(2)}</li>); }
    else if (ln.trim()) { flushList(); out.push(<p key={i}>{ln}</p>); }
  });
  flushList();
  return out;
};

export default function LegalPage({ docKey }) {
  const { lang, t } = useI18n();
  const { content } = useContent();
  const legal = content?.legal;
  const titleMap = { privacy: t("pages.privacy"), terms: t("pages.terms"), refund: t("pages.refund") };
  const body = legal ? legal[`${docKey}_${lang}`] || legal[`${docKey}_ru`] : "";

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-24 sm:pt-32 pb-16 sm:pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="legal-back">
            <ArrowLeft className="size-4" /> {t("common.back_home")}
          </Link>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-accent mb-3">Legal</div>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-8" data-testid="legal-title">
            {titleMap[docKey]}
          </h1>
          <article className="prose-custom" data-testid="legal-body">
            {renderMarkdown(body)}
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
